/** Кол-во попыток соединения при 502 ошибке */
export const RETRY_COUNT_502 = 3
